import React from "react";
import { css } from "react-emotion";

const modalContentStyles = css`
  font-size: 12px;
  line-height: 1.4;
  p {
    font-size: 12px;
  }
`;
export default ({ children }) => (
  <div
    className={modalContentStyles}
    dangerouslySetInnerHTML={{ __html: children }}
  />
);



// WEBPACK FOOTER //
// ./src/components/MarkdownContent.js